import { Filters } from '@components/utils/sendQuery'
import { alpha, menuItemClasses, paperClasses } from '@mui/material'
import Box from '@mui/material/Box'
import MenuItem from '@mui/material/MenuItem'
import MenuList from '@mui/material/MenuList'
import Popover from '@mui/material/Popover'
import { Dispatch, MouseEvent, SetStateAction, useState } from 'react'
import { useTranslation } from 'react-i18next'

type Props = {
  filters: Filters
  setFilters: Dispatch<SetStateAction<Filters>>
  disabled?: boolean
}

export const Filter = ({ filters, setFilters, disabled }: Props) => {
  const [languageAnchorEl, setLanguageAnchorEl] = useState<HTMLElement | null>(null)
  const [extensionAnchorEl, setExtensionAnchorEl] = useState<HTMLElement | null>(null)
  const [modelAnchorEl, setModelAnchorEl] = useState<HTMLElement | null>(null)
  const { t } = useTranslation()

  const handleClickLanguage = (event: MouseEvent<HTMLElement>) => {
    setLanguageAnchorEl(event.currentTarget)
  }
  //
  // const handleClickExtension = (event: MouseEvent<HTMLElement>) => {
  //   setExtensionAnchorEl(event.currentTarget)
  // }

  const handleClickModel = (event: MouseEvent<HTMLElement>) => {
    setModelAnchorEl(event.currentTarget)
  }

  const handleCloseLanguageMenu = () => {
    setLanguageAnchorEl(null)
  }
  const handleCloseExtensionMenu = () => {
    setExtensionAnchorEl(null)
  }
  const handleCloseModelMenu = () => {
    setModelAnchorEl(null)
  }

  const languageOpen = Boolean(languageAnchorEl)
  const languageId = languageOpen ? 'simple-language-popover' : undefined
  const extensionOpen = Boolean(extensionAnchorEl)
  const extensionId = extensionOpen ? 'simple-extension-popover' : undefined
  const modelOpen = Boolean(modelAnchorEl)
  const modelId = modelOpen ? 'simple-model-popover' : undefined

  const languages = [
    { value: 'en', label: t('layout.header.switch_language.english') },
    { value: 'pl', label: t('layout.header.switch_language.polish') },
  ]
  const models = [
    { value: 'e5', label: t('model.e5') },
    { value: 'three_analyzers', label: t('model.three_analyzers') },
  ]
  const extensions = [
    { value: 'excel', label: t('filters.excel') },
    { value: 'word', label: t('filters.word') },
    { value: 'pdf', label: t('filters.pdf') },
    { value: 'email', label: t('filters.email') },
    { value: 'text', label: t('filters.text') },
  ]

  return (
    <Box sx={{ mr: 2, display: 'flex' }}>
      {/* <Chip
        avatar={
          <Avatar sx={{ fontSize: '9px !important' }}>
            {filters.strategy === 'three_analyzers' ? '3A' : filters.strategy}
          </Avatar>
        }
        label={t('model.title')}
        size="small"
        onClick={handleClickModel}
      />
      <Chip
        avatar={<Avatar sx={{ fontSize: '9px !important' }}>{filters.language}</Avatar>}
        label={t('filters.language')}
        size="small"
        onClick={handleClickLanguage}
      /> */}
      {/*<Chip*/}
      {/*  avatar={*/}
      {/*    filters?.extension_filter?.length ? (*/}
      {/*      <Avatar sx={{ fontSize: '9px !important' }}>{filters?.extension_filter?.length}</Avatar>*/}
      {/*    ) : undefined*/}
      {/*  }*/}
      {/*  size="small"*/}
      {/*  label={t('filters.extensions')}*/}
      {/*  onClick={handleClickExtension}*/}
      {/*  sx={{ backgroundColor: 'success' }}*/}
      {/*/>*/}

      <Popover
        id={modelId}
        open={modelOpen}
        anchorEl={modelAnchorEl}
        onClose={handleCloseModelMenu}
        anchorOrigin={{
          vertical: 'bottom',
          horizontal: 'right',
        }}
        transformOrigin={{
          vertical: 'bottom',
          horizontal: 'left',
        }}
        sx={{
          [`& .${paperClasses.root}`]: {
            minWidth: 200,
            [`& .${menuItemClasses.root}`]: {
              py: 1.25,
            },
          },
        }}
      >
        <MenuList onMouseLeave={handleCloseModelMenu}>
          {models.map((model) => (
            <MenuItem
              sx={
                disabled
                  ? {
                      '&:hover': {
                        backgroundColor: 'transparent',
                        cursor: 'inherit',
                      },
                      '&.Mui-selected:hover': {
                        backgroundColor: (theme) => alpha(theme.palette.primary.main, 0.075),
                        cursor: 'inherit',
                      },
                    }
                  : undefined
              }
              key={model.value}
              value={model.value}
              selected={filters.strategy === model.value}
              focusVisibleClassName={''}
              onClick={
                disabled
                  ? undefined
                  : () => {
                      handleCloseModelMenu()
                      setFilters((previous) => ({ ...previous, strategy: model.value }))
                    }
              }
            >
              {model.label}
            </MenuItem>
          ))}
        </MenuList>
      </Popover>
      <Popover
        id={languageId}
        open={languageOpen}
        anchorEl={languageAnchorEl}
        onClose={handleCloseLanguageMenu}
        anchorOrigin={{
          vertical: 'bottom',
          horizontal: 'right',
        }}
        transformOrigin={{
          vertical: 'bottom',
          horizontal: 'left',
        }}
        sx={{
          [`& .${paperClasses.root}`]: {
            minWidth: 200,
            [`& .${menuItemClasses.root}`]: {
              py: 1.25,
            },
          },
        }}
      >
        <MenuList onMouseLeave={handleCloseLanguageMenu}>
          {languages.map((language) => (
            <MenuItem
              sx={
                disabled
                  ? {
                      '&:hover': {
                        backgroundColor: 'transparent',
                        cursor: 'inherit',
                      },
                      '&.Mui-selected:hover': {
                        backgroundColor: (theme) => alpha(theme.palette.primary.main, 0.075),
                        cursor: 'inherit',
                      },
                    }
                  : undefined
              }
              key={language.value}
              value={language.value}
              selected={filters.language === language.value}
              focusVisibleClassName={''}
              onClick={
                disabled
                  ? undefined
                  : () => {
                      handleCloseLanguageMenu()
                      setFilters((previous) => ({ ...previous, language: language.value }))
                    }
              }
            >
              {language.label}
            </MenuItem>
          ))}
        </MenuList>
      </Popover>
      <Popover
        id={extensionId}
        open={extensionOpen}
        anchorEl={extensionAnchorEl}
        onClose={handleCloseExtensionMenu}
        anchorOrigin={{
          vertical: 'bottom',
          horizontal: 'right',
        }}
        transformOrigin={{
          vertical: 'bottom',
          horizontal: 'left',
        }}
        sx={{
          [`& .${paperClasses.root}`]: {
            minWidth: 200,
            [`& .${menuItemClasses.root}`]: {
              py: 1.25,
            },
          },
        }}
      >
        <MenuList onMouseLeave={handleCloseExtensionMenu}>
          <MenuItem
            sx={
              disabled
                ? {
                    '&:hover': {
                      backgroundColor: 'transparent',
                      cursor: 'inherit',
                    },
                    '&.Mui-selected:hover': {
                      backgroundColor: (theme) => alpha(theme.palette.primary.main, 0.075),
                      cursor: 'inherit',
                    },
                  }
                : undefined
            }
            selected={
              filters.extension_filter?.sort((a, b) => a.localeCompare(b)).join('') ===
                extensions
                  .map((e) => e.value)
                  .sort((a, b) => a.localeCompare(b))
                  .join('') || filters.extension_filter?.length === 0
            }
            onClick={
              disabled
                ? undefined
                : () => {
                    setFilters((previous) => ({
                      ...previous,
                      extension_filter: [],
                    }))
                  }
            }
          >
            {t('filters.all')}
          </MenuItem>
          {extensions.map((extension) => (
            <MenuItem
              sx={
                disabled
                  ? {
                      '&:hover': {
                        backgroundColor: 'transparent',
                        cursor: 'inherit',
                      },
                      '&.Mui-selected:hover': {
                        backgroundColor: (theme) => alpha(theme.palette.primary.main, 0.075),
                        cursor: 'inherit',
                      },
                    }
                  : undefined
              }
              key={extension.value}
              value={extension.value}
              selected={filters.extension_filter?.includes(extension.value)}
              onClick={
                disabled
                  ? undefined
                  : () => {
                      setFilters((previous) => ({
                        ...previous,
                        extension_filter: filters.extension_filter?.includes(extension.value)
                          ? filters.extension_filter?.filter((e) => e !== extension.value)
                          : filters.extension_filter?.concat([extension.value]),
                      }))
                    }
              }
            >
              {extension.label}
            </MenuItem>
          ))}
        </MenuList>
      </Popover>
    </Box>
  )
}
